export default __webpack_public_path__ + "static/media/noNFTDonation.310b7681.png";